/*
 *  Contains utilies that help with keyboard navigation
 */

rs.module("common/keyboard-navigation", [], function () {

    //
    // Initialize for keyboard navigation
    // 
    function initialize() {

        // When the enter key is used on a focused <a> tag that has a tabindex,
        // we want to activate as if it was clicked in order to execute any attached
        // javascript handlers.
        $("a[tabindex]:not([href])").on("keydown",
            function (event) {
                if (event.which == 13) {
                    $(this).click();
                }
            }
        );

        // We look for any inputs that have a button they are supposed to trigger, and listen for enter keys on those inputs to 
        // trigger the click event on the button
        $(document).on("keydown", "input[type=text][data-enter-triggers], input[type=search][data-enter-triggers]",
            function (event) {
                if (event.which == 13) {
                    var button = $.js($(this).data("enter-triggers"));
                    button.click();
                }
            }
        );
    }

    var exports = {
        initialize: initialize
    };

    return exports;
});